import styled, { css } from 'styled-components';
import { FlexBetween } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';

export const OwnerInfoContainer = styled(FlexBetween)<{
  $isResidence: boolean;
}>`
  width: 100%;
  padding-bottom: 15px;
  gap: 15px;

  ${({ $isResidence }) =>
    $isResidence &&
    css`
      flex-direction: row-reverse;
      justify-content: flex-end;
    `}

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-bottom: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 20px 0;
  }
`;

export const OwnerInfoContent = styled.div`
  align-self: center;
`;

export const OwnerInfoCompany = styled(Typography)<{
  $isResidence: boolean;
}>`
  display: block;
  margin-bottom: 2px;

  ${({ $isResidence }) =>
    $isResidence &&
    css`
      margin-bottom: 5px;
    `}
`;

export const OwnerInfoOwnership = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const OwnerInfoLogo = styled.div`
  flex: none;
  width: 55px;
  height: 55px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  overflow: hidden;
`;
